module.exports = __webpack_public_path__ + "img/udi.87667149.png";